import "./Nav.css";
import GCULogo from "./Grand_Canyon_University_2023_Logo_Update.png";
import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Nav() {
  const { isAuthenticated, role, setAuthState } = useContext(AuthContext);
  const { toast } = useToast();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      if (role === "student") {
        await axios.post(
          `/api/student?action=logout`,
          {},
          { withCredentials: true }
        );
      } else {
        await axios.post(
          `/api/admin?action=logout`,
          {},
          { withCredentials: true }
        );
      }
      setAuthState({ isAuthenticated: false, role: null, user: null });
      navigate("/");
      setIsMenuOpen(false); // Hide menu after logout
      toast.success("You're signed out. See you next time!");
    } catch (error) {
      console.error("Logout failed", error);

      // A 401 means the session was already invalid, which is the outcome the
      // user wanted, so report it as a clean sign-out.
      if (error.response?.status === 401) {
        toast.success("You're signed out. See you next time!");
      } else if (!error.response) {
        toast.warning(
          "We signed you out here, but couldn't reach the server. Close your browser to be safe."
        );
      } else {
        toast.warning(
          "We signed you out here, but the server didn't confirm. Close your browser to be safe."
        );
      }

      // Clear locally either way. Leaving the user looking signed in with no
      // explanation is worse than clearing early; AuthContext's checkAuth
      // corrects the state on its next run.
      setAuthState({ isAuthenticated: false, role: null, user: null });
      navigate("/");
      setIsMenuOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handler to close menu when a link is clicked
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="customNav">
      <div className="left">
        <Link to="/" onClick={handleLinkClick}>
          <img className="GCULogoImage" src={GCULogo} alt="gcuLogo" />
        </Link>
      </div>

      {/* Menu Links */}
      <div className={`right ${isMenuOpen ? "menu-open" : ""}`}>
        {isAuthenticated ? (
          <>
            <Link to="/" className="LinkDashBoard" onClick={handleLinkClick}>
              Home
            </Link>
            {role !== "student" && (
              <>
                <Link
                  to="/landing"
                  className="LinkDashBoard"
                  onClick={handleLinkClick}
                >
                  Shop
                </Link>
                <Link
                  to="/signedInStudent"
                  className="LinkDashBoard"
                  onClick={handleLinkClick}
                >
                  Dashboard
                </Link>
              </>
            )}
            <Link
              to="/inventory"
              className="LinkDashBoard"
              onClick={handleLinkClick}
            >
              Inventory
            </Link>
            <Link
              to="/register"
              className="LinkDashBoard"
              onClick={handleLinkClick}
            >
              Register
            </Link>
            <button className="LinkLogout" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <Link
              to="/admin/login"
              className="LinkLogin"
              onClick={handleLinkClick}
            >
              Admin Login
            </Link>
            <Link
              to="/user/login"
              className="LinkLogin"
              onClick={handleLinkClick}
            >
              User Login
            </Link>
          </>
        )}
      </div>

      {/* Hamburger Icon */}
      <div className="hamburger" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </nav>
  );
}
